import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COLLECTION_AGGREGATE_DATA} from '../../api';
import $ from "jquery";
import cogoToast from "cogo-toast";
import moment from "moment";
import {capitalize} from "../../utils/capitalize";
import {application, getLoanApplicationReport, user} from "../../api/app";
import 'react-quill/dist/quill.snow.css';
import formatNumber from "../../utils/formatNumber";
import {useSelector} from "react-redux";
import exportToExcel from "../../utils/exporter";
import html2pdf from "html2pdf.js";
import JSZip from "jszip";
import { saveAs } from "file-saver";

let filter = {};
let application_id = null;

const searchableFields = [
    { field: 'user.name', isNumeric: false },
    { field: 'user.mobile_number', isNumeric: true },
    { field: 'user.id_number', isNumeric: false }
];

const generateLoanHtmlContent = (data) => {
    const amount = Number(data.amount || 0);

    const facilityFee = amount * (6.75 / 100);
    const insuranceFee = amount * (1.65 / 100);
    const fixedFees = 360;
    const loanAmount = amount + facilityFee + insuranceFee + fixedFees;

    const annualInterest = 8;
    const months = 12;
    const monthlyRate = annualInterest / 100 / 12;

    const monthlyRepayment =
        (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, months)) /
        (Math.pow(1 + monthlyRate, months) - 1);

    const formatMoney = (value) =>
        Number(value || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

    const agreementDate =  data?.tnc_date ? moment(data.tnc_date).format("YYYY/DD/MM") : moment().format("YYYY/DD/MM")

    return `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <title>CEEC - Loan Agreement</title>
    <meta name="viewport" content="width=device-width,initial-scale=1">

    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Ubuntu:wght@400;700&display=swap" rel="stylesheet">

    <style>
        @page { size: A4; margin: 25mm 20mm; }

        * { box-sizing: border-box; }
        
        .section-block,

        p,
        
        li,
        
        table,
        
        tr {
        
            break-inside: avoid;
        
            page-break-inside: avoid;
        
        }
        
        h1,
        
        h2,
        
        h3,
        
        span {
        
            break-after: avoid;
        
            page-break-after: avoid;
        
        }
        
        ol,
        
        ul {
        
            break-inside: auto;
        
            page-break-inside: auto;
        
        }
        
        li {
        
            break-inside: avoid;
        
            page-break-inside: avoid;
        
        }

        body {
            font-family: "Ubuntu", sans-serif;
            margin: 0;
            padding: 0;
            color: #4f4f58;
        }
        
        .signature-filled-line {
        
        text-decoration: none;

    display: inline-flex;

    align-items: flex-end;

    min-height: 24px;

    padding: 0 10px 4px 10px;

    border-bottom: 1px solid #000;

    margin: 0 15px;

    font-size: 16px;

    color: #000;

    flex: 1;

}
        
        .signature-execution-row {
    display: flex;
    align-items: center;
    margin-top: 40px;
    width: 100%;
}

.signature-label {
    font-size: 16px;
    color: #000;
    white-space: nowrap;
    text-decoration: none;
}

.signature-line {
    flex: 1;
    border-bottom: 1px solid #000;
    margin: 0 15px;
    height: 10px;
}

.borrower-signature-image {

    height: 45px;

    max-width: 220px;

    object-fit: contain;

    display: block;

}

.borrower-signature-line {

    min-height: 60px;

    align-items: center;

}

.signature-date-label {
    font-size: 16px;
    color: #000;
    margin-left: 20px;
    white-space: nowrap;
    text-decoration: none;
}

.signature-date-line {
    width: 180px;
    border-bottom: 1px solid #000;
    margin-left: 10px;
    height: 10px;
}

.borrower-line {
    max-width: 500px;
}

.borrower-contact-line {
    width: 350px;
}

.borrower-signature-line {
    max-width: 500px;
}

.borrower-date-line {
    width: 350px;
}

        h1 {
            font-weight: 700;
            font-size: 24px;
            text-align: center;
            color: #FF0000;
            margin-bottom: 16px;
        }

        h2 {
            text-align: center;
            font-weight: 700;
            font-size: 16px;
            color: #000;
        }

        h3 {
            font-weight: 700;
            font-size: 20px;
            color: #000;
            margin-top: 24px;
            margin-bottom: 10px;
        }

        span {
            font-weight: 400;
            font-size: 16px;
            text-decoration: underline;
        }

        strong {
            font-weight: 700;
            color: #000;
        }

        p {
            font-weight: 400;
            font-size: 16px;
            color: #4f4f58;
            line-height: 1.5;
            margin-top: 8px;
            margin-bottom: 8px;
        }

        table {
            border-collapse: collapse;
            width: 100%;
            margin-top: 12px;
            margin-bottom: 18px;
            page-break-inside: avoid;
        }

        table td {
            font-size: 16px;
            color: #4f4f58;
            padding: 6px 0;
        }

        ol, ul {
            padding-left: 24px;
        }

        li {
            margin-bottom: 4px;
        }

        @media screen {
            body {
                background: #e9ecef;
                margin: 0;
                padding: 24px 0;
            }

            .a4-page {
                box-sizing: border-box;
                width: 210mm;
                min-height: 297mm;
                margin: 0 auto 24px auto;
                background: #ffffff;
                box-shadow: 0 6px 24px rgba(0,0,0,0.15);
                padding: 18mm 20mm 25mm 20mm;
                overflow: hidden;
            }
        }

        .pdf-toolbar {
            text-align: center;
            margin-bottom: 16px;
        }

        .pdf-btn {
            background: #0b5ea8;
            color: #fff;
            border: none;
            padding: 10px 18px;
            font-size: 14px;
            cursor: pointer;
            border-radius: 4px;
        }

        .pdf-btn:hover {
            background: #094c88;
        }

        @media print {
            html, body {
                width: 210mm;
                height: 297mm;
                margin: 0 !important;
                padding: 0 !important;
            }

            @page {
                size: A4;
                margin: 0;
            }

            body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background: #fff;
            }

            .a4-page {
                box-sizing: border-box;
                width: 210mm;
                min-height: 297mm;
                margin: 0;
                padding: 18mm 20mm 25mm 20mm;
                box-shadow: none;
                overflow: hidden;
                page-break-after: always;
            }

            .no-print {
                display: none !important;
                visibility: hidden !important;
                height: 0 !important;
                overflow: hidden !important;
            }
        }
    </style>
</head>

<body>

<div class="pdf-toolbar">
    <button class="pdf-btn no-print" onclick="window.print()">
        ⬇ Download as PDF
    </button>
</div>

<div class="a4-page">

    <h1>
        Citizens Economic Empowerment Commission Busulu (via Imisepela) Loan Agreement
    </h1>

    <h2>
        Agreement Date: <span>${moment().format("DD-MM-YYYY")}</span>
    </h2>

    <h2 style="margin-bottom: 50px">
        Loan Agreement Number:
        <span>CEEC/BUSULU/${agreementDate}</span>
    </h2>

    <div class="mt-4">
        <h3>1. Borrower information (KYC Details)</h3>

        <span>1.1 Personal Details</span>

        <p><strong>Full Name:</strong> ${capitalize(data.user.name)}</p>
        <p><strong>National Registration Card (NRC) No:</strong> ${data.user.id_number}</p>
        <p><strong>Date of Birth:</strong> ${data.user.dob}</p>
        <p><strong>Age:</strong> ${moment().diff(moment(data.user.dob, "DD/MM/YYYY"), "years")}</p>
        <p><strong>Gender:</strong> ${capitalize(data.user.gender)}</p>
        <p><strong>Mobile Number:</strong> ${data.user.mobile_number}</p>
        <p><strong>Email Address:</strong> N/A</p>
        <p><strong>Residential Address:</strong> ${data.physical_address}</p>
        <p><strong>District/Province:</strong> ${data.user.location?.district?.name || "N/A"}, ${data.user.location?.provincial?.name || "N/A"}</p>
    </div>

    <div class="mt-5">
        <h3>2. Loan Facility Detail</h3>

        <span>2.1. Loan Product Information</span>

        <p><strong>Loan Product:</strong> Busulu Loan Product</p>
        <p><strong>Loan Type:</strong> Working Capital Financing</p>
    </div>

    <div class="mt-4 section-block">

        <span>2.2. Loan Terms and Conditions</span>

        <p>
            <strong>K${formatMoney(amount)}</strong> Broken down as follows:
        </p>

        <table>
            <tbody>
                <tr>
                    <td>Facility Fees 6.75%</td>
                    <td style="text-align: right;">: K ${formatMoney(facilityFee)}</td>
                </tr>

                <tr>
                    <td>Insurance 1.65%</td>
                    <td style="text-align: right;">: K ${formatMoney(insuranceFee)}</td>
                </tr>

                <tr>
                    <td>Enterprise Development</td>
                    <td style="text-align: right;">: K 100.00</td>
                </tr>

                <tr>
                    <td>CRB Fee</td>
                    <td style="text-align: right;">: K 100.00</td>
                </tr>

                <tr>
                    <td>PACRA Fee</td>
                    <td style="text-align: right;">: K 160.00</td>
                </tr>

                <tr>
                    <td>Net Amount Less Fees</td>
                    <td style="text-align: right;">: K ${formatMoney(amount)}</td>
                </tr>

                <tr>
                    <td><strong>Total Loan Amount</strong></td>
                    <td style="text-align: right;">
                        <strong>: K ${formatMoney(loanAmount)}</strong>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="mt-4 section-block">
        <span>2.3. Repayment Schedule</span>

        <p>
            Monthly loan repayments of
            <strong>K${formatMoney(monthlyRepayment)}</strong>
            effective from the first month preceding the loan disbursement.
        </p>
    </div>

    <div class="mt-4 section-block">
        <h3>3. Key Terms & Conditions</h3>

        <span>3.1. Interest</span>

        <p>8% per annum on the principal amount borrowed.</p>
    </div>

    <div class="mt-4 section-block">
        <span>3.2. Repayment Obligations</span>

        <ol>
            <li><p>The Borrower is obligated to repay the loan according to the agreed repayment schedule</p></li>
            <li><p>If an instalment payment date falls on a public holiday, payment shall be made on or before the day preceding a public holiday</p></li>
            <li><p>The Borrower shall provide the Commission with information regarding the operations of the business upon request</p></li>
            <li><p>Late payments negatively affect the Borrower's credit record</p></li>
        </ol>
    </div>

    <div class="mt-4 section-block">
        <span>3.3. Events of Default</span>

        <p>
            The Commission may demand immediate repayment of the entire outstanding amount if:
        </p>

        <ol>
            <li><p>The Borrower fails to pay any instalment as per the agreed schedule</p></li>
            <li><p>The loan is used for purposes other than those stated in this Agreement</p></li>
            <li><p>The Borrower provides false or misleading information</p></li>
            <li><p>There is a material adverse change in the Borrower's financial situation or business viability</p></li>
            <li><p>The Borrower becomes insolvent or bankrupt</p></li>
        </ol>
    </div>

    <div class="mt-4 section-block">
        <span>3.4. Commission's Rights</span>

        <p>
            The Commission and its authorized representatives may:
        </p>

        <ul>
            <li><p>Visit the Borrower's business and household premises to verify loan utilization and business operations</p></li>
            <li><p>Request financial records, statements, and business documentation at reasonable times</p></li>
            <li><p>Report payment status to Credit Reference Bureaus (CRB) and Debt Collection Agencies in case of default</p></li>
            <li><p>Disclose payment information to guarantors or parties securing the loan</p></li>
        </ul>
    </div>

    <div class="mt-4 section-block">
        <h3>4. Borrower Declarations & Consent</h3>

        <span>4.1. Declarations</span>

        <p>I, the undersigned Borrower, hereby declare that:</p>

        <ol>
            <li><p>All information provided in this loan agreement and supporting documents is true, complete, and accurate</p></li>
            <li><p>I have read, understood, and agree to all terms and conditions outlined in this Agreement</p></li>
            <li><p>I authorize CEEC to verify the information provided through any lawful means</p></li>
            <li><p>I understand the consequences of default and agree to bear all legal costs associated with loan recovery</p></li>
            <li><p>I consent to CEEC sharing my credit information with Credit Reference Bureaus</p></li>
            <li><p>I will use the loan solely for the stated business purpose</p></li>
            <li><p>I acknowledge my obligation to repay the full loan amount with interest as per the amortization schedule</p></li>
        </ol>
    </div>

    <div class="mt-4 section-block">
        <span>4.2. Data Protection and Privacy Consent</span>

        <p>
            I consent to the collection, processing, and storage of my personal and business data by CEEC for the purposes of this loan facility and in accordance with applicable data protection laws.
        </p>
    </div>
    
    <div class="mt-5 section-block">

    <h3 style="text-transform: uppercase;">
        SECTION 5: SIGNATURES AND EXECUTION
    </h3>

    <p style="margin-top: 30px; line-height: 2;">
        THE COMMON SEAL OF THE
        <strong>CITIZENS ECONOMIC EMPOWERMENT COMMISSION</strong>
        WAS HEREUNTO AFFIXED IN THE PRESENCE OF:
    </p>

    <div style="margin-top: 50px;">

        <div class="signature-execution-row">
            <span class="signature-label">DIRECTOR ACCESS TO FINANCE:</span>
            <span class="signature-line"></span>

            <span class="signature-date-label">DATE:</span>
            <span class="signature-date-line"></span>
        </div>

        <div class="signature-execution-row">
            <span class="signature-label">DIRECTOR LEGAL SERVICES:</span>
            <span class="signature-line"></span>

            <span class="signature-date-label">DATE:</span>
            <span class="signature-date-line"></span>
        </div>

        <div class="signature-execution-row">
            <span class="signature-label">DIRECTOR GENERAL:</span>
            <span class="signature-line"></span>

            <span class="signature-date-label">DATE:</span>
            <span class="signature-date-line"></span>
        </div>

    </div>

    <div style="margin-top: 60px;">

    <h3 style="text-transform: uppercase;">

        THE BORROWER

    </h3>

    <div class="signature-execution-row">

        <span class="signature-label">NAME:</span>

        <span class="signature-filled-line">

            ${capitalize(data.user?.name || "N/A")}

        </span>

        <span class="signature-date-label">CONTACT NO:</span>

        <span class="signature-filled-line borrower-contact-line">

            ${data.user?.mobile_number || "N/A"}

        </span>

    </div>

    <div class="signature-execution-row">
    <span class="signature-label">SIGNATURE:</span>

    <span class="signature-filled-line borrower-signature-line">
        ${
        data?.metadata?.signature
            ? `<img 
        src="${data.metadata.signature}" 
        class="borrower-signature-image"
    />`
            : ""
    }
    </span>

    <span class="signature-date-label">DATE:</span>

    <span class="signature-filled-line borrower-date-line">
        ${

        data?.tnc_date

            ? moment(data.tnc_date).format("DD-MM-YYYY")

            : moment().format("DD-MM-YYYY")

    }
    </span>
</div>

</div>

    <div style="margin-top: 70px;">
        <p style="line-height: 2; text-align: justify;">
            BEFORE ME, the undersigned authority, on this
            ________ day of __________, 20_____,
            personally appeared to me well known to be the person
            described in and who signed the foregoing, and acknowledged
            to me that he executed the same freely and voluntarily for
            the uses and purposes therein expressed.
        </p>
    </div>

</div>

</div>

</body>
</html>
`;
};

const generateHtmlContent = (data) => {
    return(
        `<!DOCTYPE html>
            <html>
            <head>
            <meta charset="utf-8">
                <title>CEEC BUSULU LOAN PRODUCT</title>
            <style>
                @page { size: A4; margin: 25mm 20mm; }
                body { font-family: Arial, Helvetica, sans-serif; }
                table { border-collapse: collapse; width: 100%; margin-bottom: 18px; page-break-inside: avoid; }
                td, th { border: 1px solid #000; padding: 8px; vertical-align: top; font-size: 13px; }
                .ceec-header { text-align: center; }
                .ceec-logo { height: 50px; }
                .ceec-title { font-size: 20px; font-weight: bold; color: #0b5ea8; }
                .ceec-subtitle { font-size: 14px; font-weight: bold; color: #000000; margin-bottom: 5px }
            </style>
        
            <style>
                /* Screen A4 page view */
                @media screen {
                body {
                background: #e9ecef;
                margin: 0;
                padding: 24px 0;
            }
                .a4-page {
                width: 210mm;
                min-height: 297mm;
                margin: 0 auto 24px auto;
                background: #ffffff;
                box-shadow: 0 6px 24px rgba(0,0,0,0.15);
                padding: 18mm 20mm 25mm 20mm;
            }
            }
        
                .pdf-toolbar {
                text-align: center;
                margin-bottom: 16px;
            }
        
                .pdf-btn {
                background: #0b5ea8;
                color: #fff;
                border: none;
                padding: 10px 18px;
                font-size: 14px;
                cursor: pointer;
                border-radius: 4px;
            }
        
                .pdf-btn:hover {
                background: #094c88;
            }
        
                .signature-row {
                display: flex;
                justify-content: space-between;
            }
        
                .signature-left,
                .signature-right {
                width: 45%;
                font-size: 13px;
            }
        
                .signature-line,
                .date-line {
                display: inline-block;
                width: 100%;
                border-bottom: 1px solid #000;
                height: 20px;
                margin-top: 36px;
            }
        
                .signature-picture {
                border-bottom: 1px solid #000;
                height: 43px;
            }
        
                /* Print A4 */
                @media print {
        
                html, body {
                width: 210mm;
                height: 297mm;
                margin: 0 !important;
                padding: 0 !important;
            }
        
                @page {
                size: A4;
                margin: 0;
            }
        
                body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
        
                .a4-page {
                width: 210mm;
                height: 297mm;          /* 🔴 FIXED HEIGHT (critical) */
                margin: 0;
                padding: 18mm 20mm 25mm 20mm;
                box-shadow: none;
                overflow: hidden;       /* 🔴 prevents reflow */
                page-break-after: always;
            }
        
                .no-print {
                display: none !important;
                visibility: hidden !important;
                height: 0 !important;
                overflow: hidden !important;
            }
            }
            </style>
        
        </head>
            <body>
            <div class="pdf-toolbar">
                <button class="pdf-btn no-print" onclick="window.print()">
                    ⬇ Download as PDF
                </button>
            </div>
            <div class="a4-page">
                <div class="ceec-header">
                    <img src="http://www.ceec.org.zm/wp-content/uploads/2018/07/ceeclogo.png" class="ceec-logo"/>
                    <div class="ceec-subtitle">MICROFINANCE LOAN PRODUCT - APPLICATION FORM</div>
                </div>
                <table>
                    <tr style="background-color: #D9D9D9">
                        <td><strong>1.0 APPLICANT INFORMATION</strong></td>
                        <td colspan="5"></td>
                    </tr>
                    <tr>
                        <td><strong>1.1 Name of Individual applying</strong></td>
                        <td colspan="5">${capitalize(data.user.name)}</td>
                    </tr>
                    <tr>
                        <td>a. Date of Birth of Applicant </td>
                        <td colspan="5">${data.user.dob}</td>
                    </tr>
                    <tr>
                        <td>b. NRC Number </td>
                        <td colspan="5">${capitalize(data.user.id_number)}</td>
                    </tr>
                    <tr>
                        <td>c. Physical Address or Residential Address </td>
                        <td colspan="5">${data.physical_address}</td>
                    </tr>
                    <tr>
                        <td>d. District </td>
                        <td colspan="5">${data.user.location?.district?.name || "n/a"}</td>
                    </tr>
                    <tr>
                        <td>e. Constituency</td>
                        <td colspan="5">${data.user.location?.constituency?.name || "n/a"}</td>
                    </tr>
                    <tr>
                        <td>f. Applicants Contact Number (linked to Airtel, MTN and ZAMTEL Mobile Money). <strong>Please note that the contact number must be registered in the Applicant name</strong></td>
                        <td colspan="5">${data.user.mobile_number || "n/a"}</td>
                    </tr>
                    <tr>
                        <td rowspan="2" style="width:45%; vertical-align:top;">
                            g. Social Distribution (Primarily targeting youths and women in rural and peri-urban areas)
                        </td>
                        <td>Youth-Female</td>
                        <td>Youth-Male</td>
                        <td>Women</td>
                        <td>Disabled</td>
                        <td>Men</td>
                    </tr>
                    <tr>
                        <td>&nbsp;${data.user.gender === "female" ? "X" : ""}</td>
                        <td>&nbsp;${data.user.gender === "male" ? "X" : ""}</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td rowspan="3">
                            h. Next of Kin details
                        </td>
                        <td>Name</td>
                        <td colspan="4">${data?.next_of_kin?.name}&nbsp;</td>
                    </tr>
                    <tr>
                        <td>Mobile Number</td>
                        <td colspan="4">${data?.next_of_kin?.mobile_number}&nbsp;</td>
                    </tr>
                    <tr>
                        <td>Physical Address</td>
                        <td colspan="4">${data?.next_of_kin?.physical_address}&nbsp;</td>
                    </tr>
                </table>
        
                <table>
                    <tr style="background-color: #D9D9D9">
                        <td colspan="2"><strong>2.0 BUSINESS AND FINANCIAL INFORMATION</strong></td>
                    </tr>
                    <tr>
                        <td>Please indicate the sector for your proposed business ( tick where applicable)</td>
                        <td>
                            <label>Agriculture ${data.business.sector === "agriculture" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Manufacturing ${data.business.sector === "manufacturing" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Trading ${data.business.sector === "trading" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>ICT ${data.business.sector === "ict" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Services ${data.business.sector === "services" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Mining ${data.business.sector === "mining" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Energy ${data.business.sector === "energy" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Tourism ${data.business.sector === "tourism" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>&nbsp;&nbsp;&nbsp;
                            <label>Construction <${data.business.sector === "construction" ? `<input type="checkbox" checked>` : `<input type="checkbox">`}</label>
                        </td>
                    </tr>
                    <tr>
                        <td>Is your business currently operational </td>
                        <td>${data.business.operational ? "Yes" : "No"}</td>
                    </tr>
                    <tr>
                        <td><strong>If yes:</strong></td>
                        <td></td>
                    </tr>
                    <tr> 
                        <td>How much do you make per month?</td>
                        <td><strong>ZMW</strong> ${data.business.operational ? data.business?.metadata?.monthly_income : ""}</td>
                    </tr>
                    <tr>
                        <td>How much do you spend per month on your business?</td>
                        <td><strong>ZMW</strong> ${data.business.operational ? data.business?.metadata?.monthly_expenses : ""}</td>
                    </tr>
                    <tr>
                        <td>How much did you spend to start your business? i.e. Capital</td>
                        <td><strong>ZMW</strong> ${data.business.operational ? data.business?.metadata?.projected_sales : ""}</td>
                    </tr>
                    <tr>
                        <td>How much will be your sales per month after the loan?</td>
                        <td><strong>ZMW</strong> ${data.business.operational ? data.business?.metadata?.startup_capital : ""}</td>
                    </tr>
                </table>
        
                <table>
                    <tr style="background-color: #D9D9D9">
                        <td colspan="3"><strong>3.0 INFORMATION ON JOB CREATION</strong></td>
                    </tr>
                    <tr>
                        <td rowspan="2" style="width:45%; vertical-align:top;">Number of Workers ( including self-employment)</td>
                        <td><strong>Before CEEC Loan</strong></td>
                        <td><strong>After CEEC Loan</strong></td>
                    </tr>
                    <tr>
                        <td>${data?.metadata?.number_of_worker}&nbsp;</td>
                        <td>${data?.metadata?._number_of_worker}&nbsp;</td>
                    </tr>
                </table>
        
                <table>
                    <tr style="background-color: #D9D9D9">
                        <td colspan="2"><strong>4.0 THE LOAN</strong></td>
                    </tr>
                    <tr>
                        <td>Indicate the loan amount applied for <strong>(K5,000 to K50,000)<br>NB: Higher loan amount within the loan threshold will be subjected to further due diligence to determine financing needs</strong></td>
                        <td><strong>ZMW</strong> ${formatNumber(data.amount)}</td>
                    </tr>
                </table>
        
                <div class="signature-row">
                    <div class="signature-left">
                        <strong>Applicant Signature:</strong><br/><br/>
                        <img src=${data?.metadata?.signature} class="signature-picture"/>
                    </div>
        
                    <div class="signature-right">
                        <strong>Date:</strong>
                        <span class="date-line">${moment(data.createdAt).format("DD.MM,YYYY")}</span>
                    </div>
                </div>
            </div>
            </body></html>`
    )
}

const Application = () => {

    document.title = "Application";

    const token = localStorage.getItem('jwtToken');
    const [reset, setReset] = useState(new Date().getTime());
    const {province, districts, constituencies, wards} = useSelector(state => state.app?.administrative);
    const [provincialSelected, setProvincialSelected] = useState(null);
    const [districtSelected, setDistrictSelected] = useState(null);
    const [constituencySelected, setConstituencySelected] = useState(null);
    const [exportLoading_, setExportLoading_] = useState(false);
    const [exportLoading, setExportLoading] = useState(false);
    const [exportProgress_, setExportProgress_] = useState({ current: 0, total: 0 });
    const [exportProgress, setExportProgress] = useState({ current: 0, total: 0 });
    const [stateReady, setStateReady] = useState(false);

    useEffect(() => {
        getLoanApplicationReport().then((response) => {
            if(!response.error) {
                $('#total-count').text(formatNumber(response.payload.total, "digit"));
                $('#total-pending').text(formatNumber(response.payload.pending, "digit"));
                $('#total-approved').text(formatNumber(response.payload.approved, "digit"));
                $('#total-rejection').text(formatNumber(response.payload.rejection, "digit"));
            }
        });
    }, [reset]);

    useEffect(() => {
        let table = $('#application').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Loan Application Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "application",
                        searchableFields,
                        filter,
                        pageSize: data.start,
                        format: 'json',
                        populate: [
                            {
                                path: "user",
                                model: "user",
                                populate: [
                                    {
                                        path: 'location.provincial',
                                        model: 'administrative'
                                    },
                                    {
                                        path: 'location.constituency',
                                        model: 'constituency'
                                    },
                                    {
                                        path: 'location.district',
                                        model: 'district'
                                    }
                                ]
                            }
                        ],
                        sort: { _id: -1 },
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
                // $.ajax(GET_COLLECTION_DATA, {
                //     type: 'POST',
                //     headers: {
                //         "Authorization": token
                //     },
                //     data: {
                //         query: $('.dataTables_filter input').val(),
                //         collection: "application",
                //         fieldname: "amount",
                //         pageSize: data.start,
                //         format: 'json',
                //         populate: [
                //             {
                //                 path: "user",
                //                 model: "user",
                //                 populate: [
                //                     {
                //                         path: 'location.provincial',
                //                         model: 'administrative'
                //                     },
                //                     {
                //                         path: 'location.constituency',
                //                         model: 'constituency'
                //                     },
                //                     {
                //                         path: 'location.district',
                //                         model: 'district'
                //                     }
                //                 ]
                //             }
                //         ],
                //         pageIndex: (data.length + data.start) / data.length
                //     },
                //     success: function (res) {
                //         let array = [];
                //
                //         res.data.map((data) => {
                //             array.push({raw: data})
                //         });
                //
                //         callback({
                //             recordsTotal: res.total,
                //             recordsFiltered: res.total,
                //             data: array
                //         });
                //     },
                //     error: function(err) {
                //         cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                //     }
                // });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data?.user?.name ? capitalize(data.user.name) : `<span class="tx-danger">No Data</span>`;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return formatNumber(data.amount);
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return capitalize(data.business.sector);
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return {
                            "pending" : `<span class="badge badge-secondary tx-white">Pending</span>`,
                            "approved" : `<span class="badge badge-success tx-white">Approved</span>`,
                            "rejected" : `<span class="badge badge-danger tx-white">Rejected</span>`
                        }[data.status];
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY");
                    },
                    "targets": 5
                }
            ]
        });

        $('#application tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            const { raw } = d;
            const op = !!raw?.business?.operational;

            const rows = [
                row('Personal Information:', [
                    'Legal Name: ' + capitalize(raw.user.name),
                    'Gender: ' +capitalize(raw.user.gender),
                    'Mobile Number: ' +raw.user.mobile_number,
                    'NRC Number: ' + raw.user.id_number,
                    'Province: ' + raw.user.location?.provincial?.name || "No Province",
                    'District: ' + raw.user.location?.district?.name || "No District",
                    'Constituency: ' + raw.user.location?.constituency?.name || "No Constituency",
                ].join('<br/>')),
                row('NRC Document:', [
                    'Photo 1: ' + `<a href='${raw.user.documents[0].uri}' class="text-secondary" target="_blank"><i class="fa fa-eye"></i> View NRC Front</a>` ,
                    'Photo 2: ' + `<a href='${raw.user.documents[1].uri}' class="text-secondary" target="_blank" href=""><i class="fa fa-eye"></i> View NRC Back</a>` ,
                ].join('<br/>')),
                row('Business Operational:', op ? 'Yes' : 'No'),
                op && row('Business:', [
                    'How much do you make per month: K' + formatNumber(raw?.business.metadata.monthly_income),
                    'How much do you spend per month on your business: K' + formatNumber(raw.business.metadata.monthly_expenses),
                    'How much did you spend to start your business: K' + formatNumber(raw.business.metadata.startup_capital),
                    'How much wil be your sales per month after the loan: K' + formatNumber(raw.business.metadata.projected_sales),
                ].join('<br/>')),
                row('Next Of Kin:', [
                    'Name: ' +raw?.next_of_kin?.name,
                    'Mobile Number: ' +raw?.next_of_kin?.mobile_number,
                    'Physical Address: ' +raw?.next_of_kin?.physical_address,
                ].join('<br/>')),
                row('Business Reference:', [
                    'Name: ' +raw.reference.name,
                    'Mobile Number: ' +raw.reference.mobile_number,
                    'Physical Address: ' +raw.reference.physical_address,
                ].join('<br/>')),
                row('Job Creation:', [
                    'Before CEEC: ' + (raw.metadata?.number_of_worker ?? '0'),
                    'After CEEC: '  + (raw.metadata?._number_of_worker ?? '0')
                ].join('<br/>')),
                actionRow(raw), // always included
            ].filter(Boolean).join('');

            return `
                <table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">
                  ${rows}
                </table>
              `;

            function row(label, html) {
                return `
                  <tr>
                    <td class="tx-semibold">${label}</td>
                    <td>${html}</td>
                  </tr>
                `;
            }

            function actionRow(data) {
                window.previewDoc = function () {
                    const htmlContent = generateHtmlContent(data);
                    const newWindow = window.open();
                    newWindow.document.open();
                    newWindow.document.write(htmlContent);
                    newWindow.document.close();
                };

                window.previewLoanDoc = function () {
                    const htmlContent = generateLoanHtmlContent(data);
                    const newWindow = window.open();
                    newWindow.document.open();
                    newWindow.document.write(htmlContent);
                    newWindow.document.close();
                }

                window.approve = function () {
                    const options = {
                        position: "top-right",
                        hideAfter: 0
                    };

                    let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                    let payload = {
                        id: data._id,
                        status: "approved"
                    }

                    application("put", payload).then((result) => {
                        hide();
                        if(!result.error) {
                            $('#application').DataTable().ajax.reload();
                            cogoToast.success("Application successfully approved.", {position: "top-right"});
                        }
                    });
                }

                window.reject = function () {
                    application_id = data._id;
                    $('#remark_form').parsley();
                    $("#modalRemark").modal("show");
                }

                return `
                  <tr>
                    <td class="tx-13 pd-0" colspan="2">
                      <div class="d-flex">Action:
                        <a href="javascript:void(0)" class="nav-link pd-t-0 pd-l-5 mark-paid-waste" onclick="previewDoc()">
                          <i class="fa fa-eye"></i> View Document
                        </a>
                        
                        <a href="javascript:void(0)" class="nav-link pd-t-0 pd-l-5 mark-paid-waste" onclick="previewLoanDoc()">
                          <i class="fa fa-eye"></i> View Loan Agreement
                        </a>
                        
                        <a href="javascript:void(0)" class="nav-link pd-t-0 pd-l-2 mark-paid-waste" onclick="approve()">
                          <i class="fa fa-check-circle"></i> Approve
                        </a>
                        
                        <a href="javascript:void(0)" class="nav-link pd-t-0 pd-l-2 mark-paid-waste" onclick="reject()">
                          <i class="fa fa-ban"></i> Reject
                        </a>
                      </div>
                    </td>
                  </tr>
                `;
            }
        }

        return () => {
            table.destroy();
        }

    }, []);

    const onAreaSelected = (data) => {
        const id = data?._id || null;
        const name = data?.name || "All Provinces";

        filter = id ? { "user.location.provincial": id } : {};

        $("#provincial-name").text(name);
        setProvincialSelected(id);

        $("#district-name").text("District");
        setConstituencySelected(null);

        $("#constituency-name").text("Constituency");
        setConstituencySelected(null);

        $('#application').DataTable().ajax.reload();
    };

    const onDistrictSelected = (data) => {
        filter = {"user.location.district": data._id};

        $("#district-name").text(data.name);
        setDistrictSelected(data._id);

        $("#constituency-name").text("Constituency");
        setConstituencySelected(null);

        $('#application').DataTable().ajax.reload();
    }

    const onConstituencySelected = (data) => {
        filter = {"user.location.constituency": data._id};
        $("#constituency-name").text(data.name);
        setConstituencySelected(data._id);

        $('#application').DataTable().ajax.reload();
    }

    const toBase64FromUrl = (url) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = () => {
                try {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.naturalWidth;
                    canvas.height = img.naturalHeight;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    resolve(canvas.toDataURL("image/png"));
                } catch (e) {
                    console.error("Canvas toDataURL failed:", e);
                    resolve(null);
                }
            };
            img.onerror = (e) => {
                console.error("Image load failed:", e);
                resolve(null);
            };
            // Cache bust to force a fresh CORS request
            img.src = `${url}?t=${Date.now()}`;
        });
    };

    const exportLoanAgreementsZip = async () => {
        setExportLoading(true);
        setExportProgress({ current: 0, total: 0 });

        const BATCH_SIZE = 500;
        const PDF_BATCH_SIZE = 10; // process 10 PDFs at a time
        let allData = [];
        let pageIndex = 1;
        let total = null;

        try {
            const firstBatch = await fetchBatch(0, BATCH_SIZE, pageIndex, true);
            total = firstBatch.total;
            allData = [...firstBatch.data];

            const totalPages = Math.ceil(total / BATCH_SIZE);

            for (let page = 2; page <= totalPages; page++) {
                const pageSize = (page - 1) * BATCH_SIZE;
                const batch = await fetchBatch(pageSize, BATCH_SIZE, page, true);
                allData = [...allData, ...batch.data];
            }

            const zip = new JSZip();

            // Split allData into chunks of PDF_BATCH_SIZE
            const chunks = [];
            for (let i = 0; i < allData.length; i += PDF_BATCH_SIZE) {
                chunks.push(allData.slice(i, i + PDF_BATCH_SIZE));
            }

            let processed = 0;

            for (let chunkIndex = 0; chunkIndex < chunks.length; chunkIndex++) {
                const chunk = chunks[chunkIndex];

                // Process each chunk in parallel
                await Promise.all(
                    chunk.map(async (item, indexInChunk) => {
                        const globalIndex = chunkIndex * PDF_BATCH_SIZE + indexInChunk;

                        try {
                            // Convert signature to base64
                            if (item?.metadata?.signature?.startsWith('http')) {
                                const b64 = await toBase64FromUrl(item.metadata.signature);
                                if (b64) item.metadata.signature = b64;
                            }

                            const htmlContent = generateLoanHtmlContent(item);
                            const wrapper = document.createElement("div");
                            wrapper.innerHTML = htmlContent;

                            wrapper.style.position = "fixed";
                            wrapper.style.left = "-9999px";
                            wrapper.style.top = `${globalIndex * 10}px`; // offset each to avoid overlap
                            wrapper.style.width = "210mm";
                            wrapper.style.opacity = "1";
                            wrapper.style.pointerEvents = "none";
                            wrapper.style.zIndex = "-1";

                            document.body.appendChild(wrapper);

                            // Wait for images to load
                            await Promise.all(
                                Array.from(wrapper.querySelectorAll('img')).map(img =>
                                    img.complete
                                        ? Promise.resolve()
                                        : new Promise(res => { img.onload = res; img.onerror = res; })
                                )
                            );

                            const pageElement = wrapper.querySelector(".a4-page");

                            const pdfBlob = await html2pdf()
                                .set({
                                    margin: 0,
                                    filename: "loan-agreement.pdf",
                                    image: { type: "jpeg", quality: 0.98 },
                                    html2canvas: {
                                        scale: 2,
                                        useCORS: true,
                                        allowTaint: false,
                                        backgroundColor: "#ffffff",
                                    },
                                    jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
                                    pagebreak: {
                                        mode: ["css", "legacy"],
                                        avoid: ["p", "li", "h1", "h2", "h3", "table", "tr", ".section-block"]
                                    },
                                })
                                .from(pageElement)
                                .outputPdf("blob");

                            document.body.removeChild(wrapper);

                            const applicantName = item.user?.name
                                ? capitalize(item.user.name).replace(/[^a-z0-9]/gi, "_")
                                : "Applicant";

                            const nrc = item.user?.id_number
                                ? item.user.id_number.replace(/[^a-z0-9]/gi, "_")
                                : item._id;

                            zip.file(`${globalIndex + 1}_${applicantName}_${nrc}_Loan_Agreement.pdf`, pdfBlob);

                        } catch (itemErr) {
                            console.error(`Failed to generate PDF for item ${globalIndex}:`, itemErr);
                            // Remove wrapper if still attached
                            const wrappers = document.querySelectorAll('[data-pdf-wrapper]');
                            wrappers.forEach(w => w.remove());
                        }

                        processed++;
                        setExportProgress({
                            current: processed,
                            total: allData.length,
                        });
                    })
                );

                // Small breathing room between chunks to free memory
                await new Promise(res => setTimeout(res, 100));
            }

            const zipBlob = await zip.generateAsync({ type: "blob" });
            saveAs(zipBlob, `Loan_Agreements_${moment().format("YYYY-MM-DD")}.zip`);

            cogoToast.success("Loan agreements exported successfully.", {
                position: "top-right",
            });

        } catch (err) {
            cogoToast.error("Loan agreement ZIP export failed. Please try again.", {
                position: "top-right",
                hideAfter: 5,
            });
        } finally {
            setExportLoading(false);
            setExportProgress({ current: 0, total: 0 });
        }
    };

    const exportData = async () => {
        setExportLoading_(true);
        setExportProgress_({ current: 0, total: 0 });

        const BATCH_SIZE = 5000;
        let allData = [];
        let pageIndex = 1;
        let total = null;

        try {
            // --- First batch: also discovers total ---
            const firstBatch = await fetchBatch(0, BATCH_SIZE, pageIndex, false);
            total = firstBatch.total;
            allData = [...firstBatch.data];
            setExportProgress_({ current: allData.length, total });

            const totalPages = Math.ceil(total / BATCH_SIZE);

            // --- Remaining batches ---
            for (let page = 2; page <= totalPages; page++) {
                const pageSize = (page - 1) * BATCH_SIZE;
                const batch = await fetchBatch(pageSize, BATCH_SIZE, page, false);
                allData = [...allData, ...batch.data];
                setExportProgress_({ current: allData.length, total });
            }

            // --- Build Excel ---
            const filteredData = allData.map(item => ({
                full_name: capitalize(item.user?.name),
                id_number: item.user?.id_number,
                gender: capitalize(item.user?.gender),
                age: calculateAge(item.user?.dob),
                mobile_number: item.user?.mobile_number?.toString(),
                province: item.user.location?.provincial?.name,
                district: item.user.location?.district?.name,
                constituency: item.user.location?.constituency?.name,
                budget_1: item.business?.metadata?.monthly_income || "N/O",
                budget_2: item.business?.metadata?.monthly_expenses || "N/O",
                budget_3: item.business?.metadata?.startup_capital || "N/O",
                budget_4: item.business?.metadata?.projected_sales || "N/O",
                kin_1: item.next_of_kin?.name,
                kin_2: item.next_of_kin?.mobile_number,
                kin_3: item.next_of_kin?.physical_address,
                ref_1: item.reference?.name,
                ref_2: item.reference?.mobile_number,
                ref_3: item.reference?.physical_address,
                ceec_1: item.metadata?.number_of_worker ?? '0',
                ceec_2: item.metadata?._number_of_worker ?? '0',
                laon: item.amount,
            }));

            const headers = [
                "Full Name", "NRC", "Gender", "Age", "Mobile Number", "Province", "District", "Constituency",
                "How much do you make per month",
                "How much do you spend per month on your business",
                "How much did you spend to start your business",
                "How much will be your sales per month after the loan",
                "Next Of Kin Name", "Next Of Kin Mobile Number", "Next Of Kin Physical Address",
                "Business Reference Name", "Business Reference Mobile Number", "Business Reference Physical Address",
                "Job Creation Before CEEC", "Job Creation After CEEC",
                "Loan Amount"
            ];

            exportToExcel(headers, filteredData, "Applications");

        } catch (err) {
            cogoToast.error("Export failed. Please try again.", { position: "top-right", hideAfter: 5 });
        } finally {
            setExportLoading_(false);
            setExportProgress_({ current: 0, total: 0 });
        }
    };

    const calculateAge = (dob) => {
        if (!dob) return '';
        const parsed = moment(dob, 'DD/MM/YYYY');
        if (!parsed.isValid()) {
            // Extract parts and clamp day to the max days in that month
            const [day, month, year] = dob.split('/').map(Number);
            const clamped = moment({ year, month: month - 1, day: 1 }); // month is 0-indexed
            clamped.date(Math.min(day, clamped.daysInMonth()));
            return clamped.isValid() ? moment().diff(clamped, 'years') : '';
        }
        return moment().diff(parsed, 'years');
    };

    const fetchBatch = (pageSize, limit, pageIndex, pdf) => {
        return new Promise((resolve, reject) => {
            $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                type: 'POST',
                headers: { "Authorization": token },
                data: {
                    collection: "application",
                    limit,
                    pageSize,
                    pageIndex,
                    // filter: !pdf ? filter : Object.assign(filter, {accepted_tnc: true, tnc_date: {$gt: "2026/05/03 00:00:00"}}),
                    filter: {accepted_tnc: true, tnc_date: {$gt: "2026/06/08 00:00:00"}},
                    format: 'json',
                    populate: [
                        {
                            path: "user",
                            model: "user",
                            populate: [
                                { path: 'location.provincial', model: 'administrative' },
                                { path: 'location.constituency', model: 'constituency' },
                                { path: 'location.district', model: 'district' },
                            ],
                        },
                    ],
                },
                success: resolve,
                error: reject,
            });
        });
    };

    const handleRemarkSubmit = () => {
        setStateReady(true);

        const options = {
            position: "top-right",
            hideAfter: 0
        };

        let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

        let payload = {
            remark: $("#remark").val(),
            id: application_id,
            status: "rejected"
        }

        application("put", payload).then((result) => {
            setStateReady(false);
            hide();
            if(!result.error) {
                resetForm("modalRemark", "remark_form");
                setReset(new Date().getTime());
                $('#application').DataTable().ajax.reload();
                cogoToast.success("Application successfully rejected.", {position: "top-right"});
            }
        });
    }

    const handleStatusChange = (data) => {
        const status = $("#tx-status");
        const table = $('#application');

        if (data === "all") {
            status.text("Select Status");
            delete filter["status"];
            delete filter["accepted_tnc"];
            table.DataTable().ajax.reload();
            return false;
        }

        if (data === "accepted") {
            delete filter["status"];
            filter = Object.assign(filter, {
                accepted_tnc: true
            });
            status.text("Accepted");
            table.DataTable().ajax.reload();
            return;
        }

        if (data === "unaccepted") {
            filter = Object.assign(filter, {
                status: "approved",
                accepted_tnc: {
                    $exists: false
                }
            });
            status.text("Not Accepted");
            table.DataTable().ajax.reload();
            return;
        }

        delete filter["accepted_tnc"];
        filter = Object.assign(filter, {
            status: data
        });

        status.text(capitalize(data));
        table.DataTable().ajax.reload();
    };

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Loan Application</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Loan Application</h4>
                    </div>

                    <div className="d-flex">
                        {exportLoading ? (
                            <div className="d-flex align-items-center mg-l-5">
                                <div style={{ minWidth: 220 }}>
                                    <div className="d-flex justify-content-between tx-11 mg-b-2">
                                        <span>Exporting PDFs...</span>
                                        <span>{exportProgress.total > 0 ? `${exportProgress.current.toLocaleString()} / ${exportProgress.total.toLocaleString()}` : "Fetching..."}</span>
                                    </div>
                                    <div className="progress" style={{ height: 6, width: 220 }}>
                                        <div
                                            className="progress-bar"
                                            role="progressbar"
                                            style={{
                                                width: exportProgress.total > 0 ? `${Math.round((exportProgress.current / exportProgress.total) * 100)}%` : "0%",
                                            }}
                                        />
                                    </div>
                                </div>
                                <span className="spinner-border spinner-border-sm mg-l-10" />
                            </div>
                        ) : (
                            <button
                                className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"
                                onClick={exportLoanAgreementsZip}
                            >
                                <i className="wd-10 mg-r-5 fa fa-file-pdf" />
                                Export Loan PDFs ZIP
                            </button>
                        )}

                        {exportLoading_ ? (
                            <div className="d-flex align-items-center mg-l-5">
                                <div style={{ minWidth: 180 }}>
                                    <div className="d-flex justify-content-between tx-11 mg-b-2">
                                        <span>Exporting...</span>
                                        <span>
                                        {exportProgress_.total > 0
                                            ? `${exportProgress_.current.toLocaleString()} / ${exportProgress_.total.toLocaleString()}`
                                            : 'Fetching...'}
                                    </span>
                                    </div>
                                    <div className="progress" style={{ height: 6, width: 180 }}>
                                        <div
                                            className="progress-bar"
                                            role="progressbar"
                                            style={{
                                                width: exportProgress_.total > 0
                                                    ? `${Math.round((exportProgress_.current / exportProgress_.total) * 100)}%`
                                                    : '0%'
                                            }}
                                        />
                                    </div>
                                </div>
                                <span className="spinner-border spinner-border-sm mg-l-10" role="status" aria-hidden="true"/>
                            </div>
                        ) : (
                            <button className="btn btn-sm pd-x-15 btn-secondary btn-uppercase mg-l-5" onClick={exportData}>
                                <i className="wd-10 mg-r-5 fa fa-upload"/> Export Excel
                            </button>
                        )}
                    </div>

                    {/*<div className="d-none d-md-block">*/}
                    {/*    <span className="dropdown">*/}
                    {/*            <button className="btn btn-sm pd-x-15 btn-outline-primary btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="provincial-name">All Provinces</span></button>*/}
                    {/*            <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>*/}
                    {/*                <a href="#" onClick={(e) => {e.preventDefault(); onAreaSelected(null)}} className="dropdown-item">All Provinces</a>*/}
                    {/*                {province?.map((item, index) => {*/}
                    {/*                    return(*/}
                    {/*                        <a href="#" key={index} onClick={(e) => {e.preventDefault(); onAreaSelected(item)}} className="dropdown-item text-capitalize">{item.name}</a>*/}
                    {/*                    )*/}
                    {/*                })}*/}
                    {/*            </div>*/}
                    {/*        </span>*/}

                    {/*    <span className="dropdown">*/}
                    {/*            <button className="btn btn-sm pd-x-15 btn-outline-info btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="district-name">District</span></button>*/}
                    {/*            <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>*/}
                    {/*                {provincialSelected ? districts?.filter((item) => item.administrative === provincialSelected).map((item, index) => {*/}
                    {/*                    return(*/}
                    {/*                        <a href="#" key={index} onClick={(e) => {e.preventDefault(); onDistrictSelected(item)}} className="dropdown-item">{capitalize(item.name)}</a>*/}
                    {/*                    )*/}
                    {/*                }) : <span className="dropdown-item">Select Province First</span>}*/}
                    {/*            </div>*/}
                    {/*        </span>*/}

                    {/*    <span className="dropdown">*/}
                    {/*            <button className="btn btn-sm pd-x-15 btn-outline-secondary btn-uppercase mg-l-5 outline-none dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i className="wd-10 mg-r-5 fa fa-globe"></i> <span id="constituency-name">Constituency</span></button>*/}
                    {/*            <div className="dropdown-menu" style={{maxHeight: 356, overflowY: "auto"}}>*/}
                    {/*                {districtSelected ? constituencies?.filter((item) => item.district === districtSelected).map((item, index) => {*/}
                    {/*                    return(*/}
                    {/*                        <a href="#" key={index} onClick={(e) => {e.preventDefault(); onConstituencySelected(item)}} className="dropdown-item">{capitalize(item.name)}</a>*/}
                    {/*                    )*/}
                    {/*                }) : <span className="dropdown-item">Select District First</span>}*/}
                    {/*            </div>*/}
                    {/*        </span>*/}
                    {/*</div>*/}
                </div>

                <div className="row row-xs">
                    <div className="col-sm-6 col-lg-3">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Loan Applications</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-count" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Pending</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-pending" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-success tx-semibold mg-b-8">Total Approved</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-approved" className="tx-normal tx-success mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-danger tx-semibold mg-b-8">Total Rejection</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-rejection" className="tx-normal tx-danger mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>

                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Loan Application List</h6>
                                <div className="d-flex tx-18 align-items-center">
                                    <div className="dropdown mg-r-10">
                                        <a href="javascript:void(0)" className="tx-13 link-03 mg-l-5 pd-0-f outline-none dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span id="tx-status">Select Status</span></a>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, 'all')}>All</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, "approved")}>Approved</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, "pending")}>Pending</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, "rejected")}>Rejection</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, "accepted")}>Accepted</a>
                                            <a className="dropdown-item" href="javascript:void(0)" onClick={handleStatusChange.bind(null, "unaccepted")}>Not Accepted</a>
                                        </div>
                                    </div>

                                    <a href="#" onClick={(e) => {
                                        setReset(new Date().getTime());
                                        e.preventDefault(); $('#application').DataTable().ajax.reload()}
                                    } className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="application" className="table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-20p">Name</th>
                                        <th className="wd-20p">Amount</th>
                                        <th className="wd-20p">Sector</th>
                                        <th className="wd-20p">Status</th>
                                        <th className="wd-20p">Date</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalRemark" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                                <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </a>
                                <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalRemark", "remark_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">Rejection</h4><p className="tx-13 tx-color-02 mg-b-0">Give reason why you rejected this application.</p></div>
                            </div>
                            <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                                <form id="remark_form" className="parsley-style-1" onSubmit={handleRemarkSubmit.bind()}>
                                    <div id="remarkWrapper" className="form-group parsley-input">
                                        <label className="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5">Remark<span className="tx-danger">*</span></label>
                                        <textarea id="remark" rows="10" className="form-control"
                                                  placeholder="Enter remark or give reason"
                                                  maxLength={180}
                                                  data-parsley-class-handler="#remarkWrapper" required/>
                                    </div>

                                    {stateReady ? <button disabled className="btn btn-primary btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : <button className="btn btn-primary btn-block">Submit</button> }
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Application;
